// import logolocal from '@/assets/img/logo.svg'
const logolocal = '@/assets/img/logo.svg'
const getters = {
  userInfo: state => state.user.userInfo,
  lang: state => state.app.lang,
  logo: state => {
    if (state.app.logo) {
      return state.app.logo
    }
    return logolocal
  },
  logoindex: state => {
    return logolocal
  },
  logoadmin: state => {
    return logolocal
  },
  name: state => {
    if (state.app.name) {
      return state.app.name
    }
    return '拓元職前培訓'
  },
  activeIndex: state => state.app.sidebar.activeIndex,
  navActiveIndex: state => state.app.navbar.activeIndex,
  // 許可權
  allAuth: state => state.user.allAuth,
  crm: state => state.user.crm,
  bi: state => state.user.bi,
  admin: state => state.user.admin,
  oa: state => state.user.oa,
  work: state => state.user.work,
  // 路由
  addRouters: state => state.permission.addRouters,
  oaRouters: state => state.permission.oaRouters,
  crmRouters: state => state.permission.crmRouters,
  biRouters: state => state.permission.biRouters,
  manageRouters: state => state.permission.manageRouters,
  // 客戶管理資訊
  messageNum: state => state.customer.messageNum,
  messageOANum: state => state.oa.messageOANum,
  // 配置資訊
  CRMConfig: state => state.app.CRMConfig
}
/**
 * 使用說明
 * import { mapGetters } from 'vuex'
 * computed: {
    ...mapGetters([
      'userInfo'
    ])
  }
 */

export default getters
